import { useEffect, useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { publicApi } from "@/lib/api";
import InquiryForm from "@/components/InquiryForm";

export default function OffMarket() {
  const { t, localized } = useLanguage();
  const [items, setItems] = useState([]);
  useEffect(() => {
    publicApi.listProperties({ off_market: true }).then(setItems).catch(() => setItems([]));
  }, []);

  return (
    <div className="bg-obsidian text-obsidian-text pt-32 pb-24 min-h-screen">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="overline text-obsidian-accent mb-3">
          {t("offmarket.label")}
        </div>
        <h1 className="font-serif text-5xl md:text-7xl leading-[1.02] tracking-tight font-light max-w-3xl">
          {t("offmarket.title")}
        </h1>
        <p className="mt-8 text-obsidian-muted text-lg max-w-2xl leading-relaxed">
          {t("offmarket.body")}
        </p>

        <div className="mt-16 grid md:grid-cols-2 gap-8">
          {items.map((p, i) => (
            <div
              key={p.id}
              data-testid={`offmarket-item-${p.reference || p.id}`}
              className="relative overflow-hidden border border-obsidian-line"
              style={{ animation: "fadeUp .9s ease-out both", animationDelay: `${i * 80}ms` }}
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={p.images?.[0]}
                  alt=""
                  className="w-full h-full object-cover"
                  style={{ filter: "blur(14px) brightness(0.55)" }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="overline text-obsidian-accent">
                    {t("offmarket_page.nda_required")}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <div className="overline text-obsidian-muted">
                  {p.location} · {p.bedrooms} bd · {p.area_m2} m²
                </div>
                <h3 className="font-serif text-2xl mt-2">
                  {localized(p.title)}
                </h3>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-24 border-t border-obsidian-line pt-16 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="overline text-obsidian-accent mb-3">
              {t("offmarket.cta")}
            </div>
            <h2 className="font-serif text-3xl md:text-4xl leading-tight font-light">
              {t("offmarket_page.confidential_title")}
            </h2>
          </div>
          <div className="md:col-span-7 [--tw-prose-body:theme(colors.obsidian-text)]">
            <div className="bg-obsidian-surface border border-obsidian-line p-8">
              <InquiryFormDark />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function InquiryFormDark() {
  return (
    <div className="offmarket-form">
      <InquiryForm testIdPrefix="offmarket-inquiry" service="offmarket" compact />
      <style>{`
        .offmarket-form label { color: #99958E; }
        .offmarket-form input, .offmarket-form textarea {
          color: #EAE6DF !important;
          border-color: #2C2E33 !important;
        }
        .offmarket-form input:focus, .offmarket-form textarea:focus {
          border-color: #C4A482 !important;
        }
        .offmarket-form button[type=submit] {
          background: #C4A482 !important;
          color: #0F1012 !important;
        }
        .offmarket-form button[type=submit]:hover {
          background: #D8BD9D !important;
        }
      `}</style>
    </div>
  );
}
